/* build-a-box.js */
(function () {
  'use strict';

  var cfg = window.__babConfig || {};
  var BUNDLE_VARIANT_ID = cfg.bundleVariantId;
  var MAX_ITEMS = cfg.maxItems || 3;

  var selected = []; // array of { productId, variantId, title, image }

  /* ── DOM refs ── */
  var grid       = document.getElementById('babGrid');
  var footer     = document.getElementById('babFooter');
  var slotsWrap  = document.getElementById('babSlots');
  var buyBtn     = document.getElementById('babBuyBtn');
  var remaining  = document.getElementById('babRemaining');
  var search     = document.getElementById('babSearch');

  if (!grid) return;

  /* ── 1. Search filter ── */
  function applySearch(query) {
    var q = query.toLowerCase().trim();
    grid.querySelectorAll('.bab-card').forEach(function (card) {
      var title = (card.dataset.title || '').toLowerCase();
      card.style.display = (!q || title.indexOf(q) > -1) ? '' : 'none';
    });
  }

  /* ── 3. Update footer slots ── */
  function updateSlots() {
    var slots = slotsWrap.querySelectorAll('.bab-slot');
    slots.forEach(function (slot, i) {
      slot.innerHTML = '';
      slot.classList.remove('bab-slot--filled');
      if (selected[i]) {
        slot.classList.add('bab-slot--filled');
        if (selected[i].image) {
          var img = document.createElement('img');
          img.src = selected[i].image;
          img.alt = selected[i].title;
          img.width = 52;
          img.height = 52;
          img.style.cssText = 'width:100%;height:100%;object-fit:cover;position:absolute;top:0;left:0;';
          slot.appendChild(img);
        } else {
          slot.innerHTML = '<span style="font-size:0.6rem;padding:4px;text-align:center;line-height:1.2;">' + selected[i].title.substring(0, 20) + '</span>';
        }
      } else {
        var plus = document.createElement('span');
        plus.className = 'bab-slot__plus';
        plus.textContent = '+';
        slot.appendChild(plus);
      }
    });
  }

  /* ── 4. Update counter & button state ── */
  function updateUI() {
    var count = selected.length;
    var left = MAX_ITEMS - count;

    if (remaining) remaining.textContent = left > 0 ? left : 0;

    // Footer visibility
    if (count > 0) {
      footer.classList.add('bab-footer--visible');
      footer.removeAttribute('aria-hidden');
    } else {
      footer.classList.remove('bab-footer--visible');
      footer.setAttribute('aria-hidden', 'true');
    }

    // Button state
    var ready = count >= MAX_ITEMS;
    buyBtn.disabled = !ready;
    buyBtn.setAttribute('aria-disabled', String(!ready));
    var btnText = buyBtn.querySelector('.bab-buy-btn__text');
    if (btnText) {
      btnText.textContent = ready
        ? 'Buy Now'
        : 'Select ' + left + ' more';
    }

    updateSlots();

    // Card disable state
    grid.querySelectorAll('.bab-card').forEach(function (card) {
      var id = card.dataset.productId;
      var isSelected = selected.some(function (s) { return s.productId === id; });
      var isFull = count >= MAX_ITEMS && !isSelected;
      card.classList.toggle('bab-card--disabled', isFull);
      card.classList.toggle('bab-card--selected', isSelected);
    });
  }

  /* ── 5. Toggle selection ── */
  function toggleCard(card) {
    var id = card.dataset.productId;
    var idx = selected.findIndex(function (s) { return s.productId === id; });

    if (idx > -1) {
      // Deselect
      selected.splice(idx, 1);
    } else {
      if (selected.length >= MAX_ITEMS) return;
      selected.push({
        productId: id,
        variantId: card.dataset.variantId,
        title: card.dataset.title || '',
        image: card.dataset.image || '',
        price: card.dataset.price || ''
      });
    }
    updateUI();
  }

  /* ── 6. Checkout: clear cart → add bundle only → redirect to /checkout ── */
  function checkout() {
    if (selected.length < MAX_ITEMS) return;
    if (!BUNDLE_VARIANT_ID) {
      alert('Bundle product not configured. Please set it in the section settings.');
      return;
    }

    buyBtn.classList.add('bab-buy-btn--loading');
    buyBtn.disabled = true;

    var properties = {};
    selected.forEach(function (item, i) {
      properties['Item ' + (i + 1)] = item.title;
      properties['_variant_' + (i + 1)] = item.variantId;
    });

    // Step 1: clear the entire cart
    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Clear cart error ' + res.status);
      return res.json();
    })
    // Step 2: add the bundle as the only item
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(BUNDLE_VARIANT_ID, 10),
            quantity: 1,
            properties: properties
          }]
        })
      });
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart error ' + res.status);
      return res.json();
    })
    // Step 3: go directly to checkout
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      buyBtn.classList.remove('bab-buy-btn--loading');
      buyBtn.disabled = false;
      console.error('[build-a-box] checkout error:', err);
      alert('Something went wrong. Please try again.');
    });
  }

  /* ── Event listeners ── */

  // Card click — delegate
  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('.bab-card__btn');
    if (btn) {
      var card = btn.closest('.bab-card');
      if (card && !card.classList.contains('bab-card--disabled')) {
        toggleCard(card);
      }
      return;
    }
    // Also allow clicking the card image area to add
    var card = e.target.closest('.bab-card');
    if (card && !card.classList.contains('bab-card--disabled')) {
      var clickedBtn = e.target.closest('.bab-card__btn');
      if (!clickedBtn) {
        toggleCard(card);
      }
    }
  });

  // Buy button
  if (buyBtn) {
    buyBtn.addEventListener('click', checkout);
  }

  // Search
  if (search) {
    search.addEventListener('input', function () {
      applySearch(this.value);
    });
  }

  /* ── Init ── */
  updateUI();

})();
